import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/minimize-alt.vue
var o = {
	name: "DtIconMinimizeAlt",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--minimize-alt"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Minimize Alt",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1.5 9a.5.5 0 0 1 .5-.5h8a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=minimize-alt.js.map